module.exports = __webpack_public_path__ + "static/Cervical-826-interruption-safety-large-V3-d3e869bcd948db7257975f99c9a93bfc.png";